export interface BookingStat {
  bookingsMadeCurrentYear: number; // Ventas - Ayer 30
  bookingsMadePastYear: number; // se usa para calcular el -10% en Ventas - Ayer
  cancellationsMadeCurrentYear: number; // Cancelaciones - Ayer 5
  cancellationsMadePastYear: number; // se usa para calcular el +20% en Ventas - Ayer
  avgStayInDaysCurrentYear: number; // Estancia Media - Ayer (dias)
  avgStayInDaysPastYear: number; //  se usa para calcular el +20% en Estancia Media - Ayer (dias)
  horizonDate: Date;
}

export type TraslatedItem = {
  description: string;
  label: string;
  locale: string;
  value: string;
  actionLabel: string;
};

export interface EngineDashboardElement {
  id: string;
  read?: boolean;
  description?: string;
  action: DashboardAction;
  value?: string | number | boolean;
  createdAt?: Date;
  translationList?: TraslatedItem[];
}

export type BestSellingItem = {
  name: string;
};

export interface ReservationInfo {
  id: number;
  originalDBId: number;
  propertyId: string;
  bookingId: string;
  multipleBookingId: string;
  bookingDate: Date;
  checkin: Date;
  checkout: Date;
  customer: Customer;
  rooms: number;
  totalAmount: number;
  guaranteeAmount: number;
  currency: string;
  status: string;
  statusConfig: number;
  paymentStatus: string;
  paymentType: string;
  nights: number;
  inventoryTicker: string;
  accommodationTicker: string;
  configurationTicker: string;
  mealPlanTicker: string;
  conditionTicker: string;
  capacity: number;
  advance: number;
  userEmailStatus: string;
  hotelEmailStatus: string;
  extras: string;
  promotions: string;
  comments: string;
  country: string;
  isCombined: boolean;
  promoCode: string;
  isLoyalty: boolean;
}

export interface Customer {
  name: string;
  lastName: string;
  email: string;
  phone: string;
}

export enum DashboardAction {
  SHOW_MODAL = "SHOW_MODAL",
  OPEN_URL = "OPEN_URL",
  SHOW_CALENDAR = "SHOW_CALENDAR",
}

export enum BookingFilterCriteria {
  BY_BOOKING_DATE = "booking",
  BY_BOOKING_CHECKOUT_DATE = "checkOut",
  BY_CHECKIN_DATE = "booking",
  BY_CHECKOUT_DATE = "checkOut",
}

export type FilterLabelValue = {
  days: number;
};

export interface FilterDashboard {
  labelName: string;
  labelValue?: FilterLabelValue;
  value: string;
}

type CalendarAction = "SHOW_CALENDAR";
type ModalAction = "SHOW_MODAL";

interface UnavailableDate {
  id: string | undefined;
  description: string;
  action: CalendarAction;
  value: string;
}

interface Discount {
  id: string;
  description: string;
  action: ModalAction;
  value: string;
}

interface Product {
  id: string;
  description: string;
  action: ModalAction;
  value: string;
}

interface MealPlan {
  id: string;
  description: string;
  action: ModalAction;
  value: string;
}

interface MyMotor {
  nextUnavailableDate: UnavailableDate | undefined;
  bestSellingDiscount: Discount | undefined;
  bestSellingProduct: Product | undefined;
  bestSellingPromotionalCode: Record<string, never>; // No information provided
  bestSellingMealPlan: MealPlan | undefined;
}

interface BestSelling {
  bestSellingProductList: BestSellingItem[] | undefined;
  bestSellingDiscountList: BestSellingItem[] | undefined;
  bestSellingPromotionalCodeList: unknown[] | undefined; // o any[]
  bestSellingMealPlanList: BestSellingItem[] | undefined;
}

export type MotorData = {
  myMotor: MyMotor | undefined;
  bestSelling: BestSelling | undefined;
};

export type AllMotorData = BestSelling & MyMotor;

export type DataModalProps = {
  title: string;
  description: string;
  value?: string | number | boolean;
  ranking: RankingProp[];
};

export type DataModalCalendarProps = {
  title: string;
  notAvailableDates?: Date[] | [];
};

export interface ChartDataDashboard {
  x: number;
  y: number;
  formattedY: string;
  fullDate: string;
}

export type RankingProp = {
  [name: string]: string;
};
